import React, { FC } from "react";
import { Element } from "../../../../models/elementModel";
import { TabModel } from "../../../../models/tabModel";
import CollapseItemProperties from "./collapseContentProperties";


export interface CollapseElementPropertiesProps {
  card: TabModel[];
}

const CollapseProperties: FC<CollapseElementPropertiesProps> = ({
  card,
}) => {

  const renderTabList = () => {
    return card.map((card, i) => {
    return <CollapseItemProperties card={card}/>
    });
  };

  return (
    <div className="container-fluid">
      {renderTabList()}
    </div>
  );
};

export default CollapseProperties;
